module.exports = __webpack_public_path__ + "img/gzbz.664534e7.png";